/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AuditEntryDto,
} from '../models/index';
import {
    AuditEntryDtoFromJSON,
    AuditEntryDtoToJSON,
} from '../models/index';

export interface GetAuditRequest {
    entityType: string;
    entityId?: string;
    page?: number;
    size?: number;
}

/**
 * 
 */
export class AuditApi extends runtime.BaseAPI {

    /**
     * Get audit changes for dunning entities as a flat list (one row per changed field)
     * Get audit entries
     */
    async getAuditRaw(requestParameters: GetAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AuditEntryDto>>> {
        if (requestParameters.entityType === null || requestParameters.entityType === undefined) {
            throw new runtime.RequiredError('entityType','Required parameter requestParameters.entityType was null or undefined when calling getAudit.');
        }

        const queryParameters: any = {};

        if (requestParameters.entityType !== undefined) {
            queryParameters['entityType'] = requestParameters.entityType;
        }

        if (requestParameters.entityId !== undefined) {
            queryParameters['entityId'] = requestParameters.entityId;
        }

        if (requestParameters.page !== undefined) {
            queryParameters['page'] = requestParameters.page;
        }

        if (requestParameters.size !== undefined) {
            queryParameters['size'] = requestParameters.size;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/audit`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AuditEntryDtoFromJSON));
    }

    /**
     * Get audit changes for dunning entities as a flat list (one row per changed field)
     * Get audit entries
     */
    async getAudit(requestParameters: GetAuditRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AuditEntryDto>> {
        const response = await this.getAuditRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
